import React from 'react';
import Accordion from '../features/Instructions/components/Accordion';
import ShortInstruction from '../features/Instructions/components/ShortInstruction';

const Instructions = () => {
  return (
    <div className="sm:flex min-h-screen items-start justify-center bg-gradient-to-r p-2 sm:p-4 from-[#ededed] to-[#dcdcdc]">
      <div className="max-w-5xl mx-auto w-full">
        <h2 className="truncate text-xl sm:text-3xl font-normal my-4">Инструкции</h2>

        <div className="flex flex-col gap-4">
          <Accordion title={'Пошаговая настройка устройства Kolibri'} description={'Руководство по установке и подключению'}>
            <ShortInstruction />
          </Accordion>
        </div>
      </div>
    </div>
  );
};
export default Instructions;
